<template>
  <div class="invoice-tax-rate-add">
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">姓名：</span>
        </div>
        <div>
          <el-select v-model="formData.personCode" filterable remote reserve-keyword :remote-method="remoteMethod" placeholder="请输入关键字搜索" size="small" style="width: 280px" @change="changePerson">
            <el-option v-for="item in personList" :key="item.code"
                       :label="item.name" :value="item.code">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">手机号：</span>
        </div>
        <el-input v-model="formData.phone" size="small" style="width: 280px" disabled />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">人员类型：</span>
        </div>
        <el-select v-model="formData.type" size="small" style="width: 280px">
          <el-option v-for="item in typeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import $ from "jquery";
import { api } from "../../api/Inspection";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";

export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "inspect-person-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧巡检",
          name: "inspection-device-type-manage"
        },
        {
          value: "巡检人员管理"
        }
      ],
      mainTitle: "添加巡检人员",
      subheading: "",

      personList: [],
      typeList: [
        {
          code: "0",
          name: "巡检执行人员"
        },
        {
          code: "1",
          name: "巡检管理员"
        }
      ],
      formData: {
        personCode: "",
        name: "",
        phone: "",
        type: "0"
      }
    };
  },
  created() {
    // this.getResponsiblePersonList()
    this.remoteMethod();
  },
  methods: {
    remoteMethod(query) {
      this.getResponsiblePersonList(query);
    },

    // 获取人员列表
    getResponsiblePersonList(searchKey) {
      this.$axios
        .post(api.getResponsiblePersonList, { searchKey: searchKey || "" })
        .then(res => {
          if (res.data.retCode === 1) {
            this.personList = res.data.data;
          }
        })
        .catch(errorHandler("获取人员列表失败"));
    },

    // 选择人员
    changePerson() {
      this.personList.map(v => {
        if (v.code === this.formData.personCode) {
          this.formData.phone = v.phone;
        }
      });
    },

    toManagePage() {
      this.$router.push({
        name: "inspection-person-manage"
      });
    },

    confirm() {
      if (!this.formData.personCode) {
        nError("请选择人员");
        return false;
      }
      this.personList.map(person => {
        if (this.formData.personCode === person.code) {
          this.formData.name = person.name;
        }
      });
      this.$axios
        .post(api.addInspectPerson, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.toManagePage();
          }
        })
        .catch(errorHandler("添加失败"));
    },
    cancel() {
      this.toManagePage();
    }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
  vertical-align: sub;
}
.form-line {
  margin: 20px 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.form-line > div {
  margin-right: 20px;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 122px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 110px 0 140px;
  margin: 40px 0 0 0;
  display: flex;
  justify-content: space-between;
}
.newly2 {
  display: inline-block;
  width: 80px;
  height: 80px;
  vertical-align: text-top;
  border: 1px dashed #d7d7d7;
  margin-right: 20px;
  position: relative;
}
.newly2 span {
  display: block;
  width: 100%;
  color: #999999;
  margin: 0;
  padding: 0;
  text-align: center;
}
.newly2 span:first-child {
  font-size: 28px;
  line-height: 40px;
  position: absolute;
  top: 15px;
}
.newly2 span:last-child {
  font-size: 14px;
  line-height: 20px;
  position: absolute;
  bottom: 0;
}
.upload2 {
  display: inline-block;
  width: 80px;
  height: 80px;
  vertical-align: text-top;
  background-size: 100% 100%;
  position: relative;
}

.upload2 img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}
.upload2 b {
  display: inline-block;
  width: 100%;
  line-height: 21px;
  color: white;
  background-color: #989796;
  text-align: center;
  position: absolute;
  bottom: 0;
  opacity: 0.7;
}
</style>

<style lang="less">
.invoice-tax-rate-add {
  .el-switch {
    height: 30px;
  }
  .el-input-number.is-controls-right .el-input__inner {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Inspection/InspectionPerson/InspectionPersonAdd.vue